import { gameState } from "appworks/model/game-state";
import { Exit } from "appworks/state-machine/data/exit";
import { Decision } from "appworks/state-machine/decisions/decision";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";

export class FreespinsTriggeredDecision extends Decision {
    public evaluate() {
        const gameplay = gameState.getCurrentGame();
        let record = gameplay.getCurrentRecord();

        if (!(record instanceof SpinRecord) && record.lastChild) {
            record = record.parent;
        }

        return record.getFreespinsWon() > 0 && gameplay.areFreespinsPending() ? Exit.True : Exit.False;
    }
}
